export default __webpack_public_path__ + "static/media/default-avatar.334aaa2f.svg";